import styled from "@emotion/styled";
import { Container, Grid, keyframes } from "@mui/material";
import React from "react";
import { Heading, P, SectionHeading,SectionWrapper, } from "../../../Styles/style";
import AccordianMain from "../../../Components/Accordian/Accordian";

const Custom = styled(Grid)`
  padding: 5px 0;
  @media screen and (max-width: 1105px) {
    /* padding: 150px 0 70px 0px; */
  }
`;
const LineImg = styled.img`
width: 100%;
/* max-width: 200px; */
`;
const TOtalSupply = styled.div`

background-color:#000;
  padding:6px 0;
`
const Liqi = styled.div`
background-color:#73BB61;
  padding:6px 0;
`
const Cex = styled.div`
background-color: ${(props) => props.bgcolor ? props.bgcolor : "#59A447"};
  padding:6px 0;
`

const pressAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
`;
const ReadMore = styled.a`
color: #000;
font-family: "P-SM";
background: ${(props) => (props.bgcolor ? props.bgcolor : "#E6BD23")};
padding: 9px 25px;
border:2px solid #000;
box-shadow:inset 0px 1px 8px #ffffff91,-6px 5px 1px 1px #000;
text-decoration: none;
margin:20px 0;
&:active {
    box-shadow: none;
    transform: scale(0.9);
    box-shadow: inset 0px 1px 8px #ffffff91;
  }

  animation: ${props => props.pressed ? pressAnimation : null} 0.3s ease-in-out;

`
const Index = () => {
  return (
    <div>
      <SectionWrapper bgColor="#0E0E0E" align="center" p="4rem 0" id="howtobuy">
        <Container>

          <SectionHeading color="#6FAE5F" p="40px 0" align="center" data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="300"
                data-aos-offset="0"
                data-aos-duration="500">
            How to Buy?
          </SectionHeading>
          <Heading align="center" color="#fff" data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="400"
                data-aos-offset="0"
                data-aos-duration="500">Ready to start your journey with $PehPeh? Simply follow our guide.
                Our community telegram is always available for any questions or assistance.
                Join us now and experience the power of $PehPeh.</Heading>
          <ReadMore  href="https://t.me/pehpehcoineth" target="_blank" data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="500"
                data-aos-offset="0"
                data-aos-duration="500">Join Telegram</ReadMore>
          <br/>
          <br/>
          <AccordianMain/>
          
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default Index;
